import { useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import SearchForm from './SearchHead/SearchForm'
import SearchLabels from './SearchResult/SearchLabels'

const SearchHead = () => {
  const description = useSelector((state) => state.items.description || '...')
  const title = useSelector(
    (state) =>
      state.items.headTitle || I18n.t('cars.index.search_for_classic_car')
  )

  useLayoutEffect(() => {
    const serverHeading = document.getElementById('server-rendered-heading')
    if (serverHeading) serverHeading.remove()
  }, [])

  return (
    <div className="mt-6 mb-3">
      <Heading title={title} description={description} />
      <SearchForm />
      <SearchLabels />
    </div>
  )
}

const Heading = ({ title, description }) => (
  <header>
    <h1>{title}</h1>
    <h2 className="show-more-description lead mb-5">{description}</h2>
  </header>
)

export default SearchHead
